/* eslint-disable max-len */
import { useRef, useState } from "react";
import arrowBottomIcon from "assets/arrow_bottom.svg";
import useOutsideClick from "hooks/useOutsideClick";

interface IOptionData {
  label: string;
  value: string;
}

interface ISelectData {
  value?: string | number;
  label?: string;
  options?: IOptionData[];
  onChange?: (field: string, value: any) => void;
  className?: string;
  errorMsg?: string;
  cyId?: string;
}

const Select = ({
  value = "",
  label = "",
  options = [],
  onChange,
  className = "",
  cyId = "",
  errorMsg
}: ISelectData) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOther, setIsOther] = useState<string>("");
  const ref = useRef<HTMLButtonElement>(null);
  const otherInputRef = useRef<HTMLInputElement>(null);
  useOutsideClick(ref, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const handleOnChange = (optionValue: string) => {
    if (onChange) {
      if (optionValue === "Other") {
        setIsOther("Other");
        onChange("pronoun", "");
        setTimeout(() => {
          if (otherInputRef?.current) {
            otherInputRef.current.focus();
          }
        }, 0);
      } else {
        onChange("pronoun", optionValue);
        setIsOther("");
      }
    }
  };
  return (
    <div className={className}>
      <div className="relative">
        <button
          className={`w-full outline-none font-['Inter'] px-3 pt-[16px] cursor-pointer text-left text-[16px] font-['Inter'] font-normal ${
            !isOther && value === "" ? "pb-[30px]" : "pb-[6px]"
          } ${
            isOpen || isOther ? "rounded-t-lg" : "rounded-lg"
          } bg-[#FAF9F7] border border-[#CCC7C0] focus:!border-mono-primary hover:bg-[rgba(48,47,46,0.1)]`}
          onClick={() => setIsOpen((prevState) => !prevState)}
          ref={ref}
          data-cy={`${cyId}-wrapper`}
          type="button"
        >
          <div>
            {label && (
              <label
                data-cy={`${cyId}-selected`}
                className={
                  value || isOther
                    ? "absolute top-[5px] left-[14px] font-['Inter']"
                    : "pointer-events-none absolute top-[16px] left-[14px] font-['Inter'] transition-all ease-in-out duration-150 caption text-[16px]"
                }
              >
                {label}
              </label>
            )}
          </div>
          <div className="mt-[8px]">{isOther || value}</div>
        </button>
        <div>
          {isOpen && (
            <div className="w-full absolute z-10 top-[55px] bg-[#FAF9F7] rounded-b-lg border border-[#CCC7C0]">
              {options.map((option: IOptionData) => (
                <button
                  className="py-[9px] pl-3 border-none cursor-pointer w-full text-left text-[16px] font-['Inter'] font-normal hover:bg-mono-50 focus:bg-mono-50"
                  key={option.value}
                  onClick={() => handleOnChange(option.value)}
                  type="button"
                  data-cy={cyId}
                >
                  {option.label}
                </button>
              ))}
            </div>
          )}
        </div>
        <div>
          <img
            className={`${
              isOpen ? "rotate-180" : ""
            } absolute right-2 top-1/2 -translate-y-1/2`}
            src={arrowBottomIcon}
            alt="select arrow"
          />
        </div>
      </div>
      <div>{errorMsg && <span>{errorMsg}</span>}</div>
      {isOther && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="w-full bg-[#FAF9F7]"
          aria-hidden
        >
          <input
            className="w-full rounded-b-lg outline-none px-3 py-4 bg-[#FAF9F7] text-base font-['Inter'] font-normal border !border-[#CCC7C0] focus:!border-mono-primary"
            value={value}
            onChange={(e) => onChange && onChange("pronoun", e.target.value)}
            placeholder="e.g. They/Their"
            data-cy="other-pronoun-input"
            ref={otherInputRef}
          />
        </div>
      )}
    </div>
  );
};

export default Select;
